"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Profile = /** @class */ (function () {
    function Profile() {
        this.hasMasterPin = false;
    }
    return Profile;
}());
exports.Profile = Profile;
//# sourceMappingURL=Profile.js.map